import * as NamaCommon from "../common/NamaCommon";
import * as cmn from "../common/NamaCommon";
import {ajaxJSON} from "../common/NamaCommon";
import * as NamaURLS from '../constants/NamaURLS';
import * as urls from '../constants/NamaURLS';
import {currentLegalEntity, currentUserEmployeeId, currentUserId, currentUserName, currentUserSettings} from "../login/LoginPresenter";
import {NamaRouterInstance} from "../routing/NamaRouter";
import {EntityListPlace, linkToRef} from "../routing/places";
import {translateId, translateRef} from "../common/Translator";
import {ApproveEditScreen} from "../views/edit/ApproveEditScreen";
import {NamaKendoWindow} from "../views/NamaKendoWindow";
import {questionFiled} from "../views/edit/EditScreenMoreMenu";
import * as DomainBaseEntities from "../constants/DomainBaseEntities";
import {QuestionFieldsEditor} from "./QuestionFieldsEditor";
import * as FieldType from "../constants/FieldType";
import {findQuestionObjFieldVal} from "../views/Navbar";
import * as metadata from "../common/Metadata";
import * as OwnerType from "../constants/OwnerType";
import * as PreferencesRequest from "../constants/PreferencesRequest";
import {of} from "./ActionPlaceholder";
import {ActionHandler} from "./ActionHandler";
import * as CommonFieldIds from "../constants/CommonFieldIds";
import {createGenericValueForType} from "../actions/GenericValues";
import {GuiActionPerformer} from "./GuiActionPerformer";
import * as app from "../views/mainapp";
import {logout} from "../login/Security";
import * as ConstantViewNames from "../constants/ConstantViewNames";
import {toCSVLineWithSep} from "../common/StringUtils";
import * as notifier from "../common/ErrorsNotification";
import {toString} from "../common/FieldTypesUtils";

let lastNotificationMsg;
let lastNotificationsCount = 0;
let lastApprovalsCount = 0;

export function resetNotificationsApprovalsCount() {
    lastNotificationsCount = 0;
    lastApprovalsCount = 0;
    lastNotificationMsg = "";
}

export function update() {
    let event = new CustomEvent("updateApprovalsCounter");
    event.initEvent("updateApprovalsCounter", true, true);
    let request = {
        employeeId: currentUserEmployeeId(),
        userId: currentUserId()
    };
    NamaCommon.ajaxJSONWithoutWait(NamaURLS.UPDATE_APPROVALS_AND_NOTIFICATIONS, request, (data) => {
        $("#navbarApprovalsCounter").text(data.counters.approvalsCount > 99 ? '99+' : data.counters.approvalsCount);
        $("#navbarNotificationsCounter").text(data.counters.notificationsCount > 99 ? '99+' : data.counters.notificationsCount);
        if (data.counters.notificationsCount === 0)
            $("#notificationsTitle").text(translateId("noNewNotifications"));
        else
            $("#notificationsTitle").text(translateId("youHaveNewNotifications"));
        if (data.counters.approvalsCount === 0)
            $("#approvalsTitle").text(translateId("noNewApprovals"));
        else
            $("#approvalsTitle").text(translateId("youHaveNweApprovals"));
        if (lastApprovalsCount !== data.counters.approvalsCount || lastNotificationsCount !== data.counters.notificationsCount) {
            lastApprovalsCount = data.counters.approvalsCount;
            lastNotificationsCount = data.counters.notificationsCount;
            let request = {
                employeeId: currentUserEmployeeId(),
                userId: currentUserId()
            };
            NamaCommon.ajaxJSONWithoutWait(NamaURLS.List_TOP_APPROVALS_AND_NOTIFICATIONS, request, (data) => {
                let notificationList = $("#notificationsList");
                notificationList.find("ol").empty();
                $.each(data.notifications.list, function (i, v) {
                    notificationList.find("ol").append(`<li> ${v} </li>`);
                });
                let approvalList = $("#approvalList");
                approvalList.find("ol").empty();
                $.each(data.approvals.list, function (i, v) {
                    let summary = v.values["summary"] || "";
                    let ref = v.values["approvedElement"];
                    let appCaseId = v.values["apcase.id"];
                    approvalList.find("ol").append(`<li><a href="${linkToRef(ref)}">${translateRef(ref)}</a>&nbsp;&nbsp;${summary}
            <button class="btn btn-info approve" id = '${appCaseId}'>
            <span class="fa fa-thumbs-o-up"></span>
            </button>
           </li>`);
                });
                approvalList.find(".approve").kendoButton({
                    click: function (e) {
                        let approvalCaseID = this.element.attr('id');
                        /***
                         * @type namaTypes.DTOApprovalCase
                         */
                        approveCase(approvalCaseID);
                    },
                });
                if (!data.notifications || !data.notifications.list || !data.notifications.list.length) {
                    setTimeout(() => update(), 5000);
                    return;
                }
                let msg = toCSVLineWithSep("<hr/>", data.notifications.list);
                if (lastNotificationMsg !== msg) {
                    lastNotificationMsg = msg;
                    notifier.showInfo("", msg);
                }
            });
        }
        setTimeout(() => update(), 5000);
    });

}

export function approvalsAndNotificationsEvents() {
    $("#allNotifications").click(function () {
        let listPlace = new EntityListPlace();
        listPlace.entityType = "ApprovalDefinition";
        listPlace.ascending = false;
        listPlace.listViewName = ConstantViewNames.EMPLOYEE_READ_NOTIFICATIONS_SCREEN_NAME;
        NamaRouterInstance.goTo(listPlace);
    });
    $("#allApprovals").click(function () {
        let listPlace = new EntityListPlace();
        listPlace.entityType = "ApprovalDefinition";
        listPlace.listViewName = ConstantViewNames.EMPLOYEE_APPROVALS_SCREEN_NAME;
        NamaRouterInstance.goTo(listPlace);
    });
    $('.currentUserName').html(currentUserName());
    $('#currentLegalEntity').text(currentLegalEntity());
    $("#currentLegalEntity").click(function (e) {
        e.preventDefault();
        showChangeDimsDialog();
    });
}

export function approveCase(apCaseId) {
    cmn.ajaxJSON(NamaURLS.Find_Approval_Case_By_Id, {approvalCaseID: apCaseId}, (appCase) => {
        new ApproveEditScreen({
            performApprove: function (request) {
                cmn.ajaxJSON(NamaURLS.APPROVE, {request: JSON.stringify(request)}, (res) => {
                    NamaRouterInstance.currentPresenter.onRefresh();
                });
            },
            currentApprovalCase: function () {
                return appCase;
            },
            entityType: appCase.approvedElement.entityType,
            id: appCase.approvedElement.id
        }, appCase).showPopup();
    });
}

function calculateOtherDims(entityType, value, questionFieldsEditor) {
    if (!value)
        return;
    let request = {
        dimensionEntityType: entityType, dimensionId: value.id
    };
    cmn.ajaxJSON(NamaURLS.CalculateDimensions,
        {req: JSON.stringify(request)}, (result) => {
            if (!result.list)
                return;
            for (let dim of result.list) {
                if (!dim)
                    continue;
                if (dim.entityType === DomainBaseEntities.AnalysisSet)
                    questionFieldsEditor.valueWidgets["analysisSet"].setValue(dim);
                else if (dim.entityType === DomainBaseEntities.Department)
                    questionFieldsEditor.valueWidgets["department"].setValue(dim);
                else if (dim.entityType === DomainBaseEntities.Branch)
                    questionFieldsEditor.valueWidgets["branch"].setValue(dim);
                else if (dim.entityType === DomainBaseEntities.LegalEntity)
                    questionFieldsEditor.valueWidgets["legalEntity"].setValue(dim);
            }
        });
}

function showChangeDimsDialog() {
    let questionFieldsEditor = new QuestionFieldsEditor();
    /**
     *
     * @type {namaTypes.NamaWindowBtnData}
     */
    let okBtnData = {
        btnTitle: "ok", btnAction: () => {
            let filledQuestionFields = questionFieldsEditor.getQuestionFields();
            app.instance.loginInfo.dimensions.legalEntity = findQuestionObjFieldVal(filledQuestionFields, "legalEntity");
            app.instance.loginInfo.dimensions.branch = findQuestionObjFieldVal(filledQuestionFields, "branch");
            app.instance.loginInfo.dimensions.sector = findQuestionObjFieldVal(filledQuestionFields, "sector");
            app.instance.loginInfo.dimensions.department = findQuestionObjFieldVal(filledQuestionFields, "department");
            app.instance.loginInfo.dimensions.analysisSet = findQuestionObjFieldVal(filledQuestionFields, "analysisSet");
            app.instance.loginInfo.barCodeOn = findQuestionObjFieldVal(filledQuestionFields, "BARCODEON");
            app.instance.loginInfo.hijriDate = findQuestionObjFieldVal(filledQuestionFields, "hijriDate");
            app.instance.loginInfo.alwaysPrint1InBarcode = findQuestionObjFieldVal(filledQuestionFields, "alwaysPrint1InBarcode");
            app.instance.loginInfo.directPrint = findQuestionObjFieldVal(filledQuestionFields, "directPrint");
            app.instance.loginInfo.userInfo.settings.printDocumentsOnSave = findQuestionObjFieldVal(filledQuestionFields, "printDocumentsOnSave");
            changeDimWindow.closeWindow();
            reLogin(app.instance.loginInfo);
        }
    };
    /**
     *
     * @type {namaTypes.NamaWindowBtnData}
     */
    let cancelBtnData = {
        btnTitle: "cancel"
    };
    let changeDimWindow = new NamaKendoWindow("selectLegalEntity", okBtnData, cancelBtnData);
    let questionFields = [];
    questionFields.push(questionFiled("legalEntity", DomainBaseEntities.LegalEntity, FieldType.Reference));
    questionFields.push(questionFiled("branch", DomainBaseEntities.Branch, FieldType.Reference));
    questionFields.push(questionFiled("sector", DomainBaseEntities.Sector, FieldType.Reference));
    questionFields.push(questionFiled("department", DomainBaseEntities.Department, FieldType.Reference));
    questionFields.push(questionFiled("analysisSet", DomainBaseEntities.AnalysisSet, FieldType.Reference));
    questionFields.push(questionFiled("BARCODEON", DomainBaseEntities.AnalysisSet, FieldType.Boolean));
    questionFields.push(questionFiled("alwaysPrint1InBarcode", DomainBaseEntities.AnalysisSet, FieldType.Boolean));
    questionFields.push(questionFiled("directPrint", DomainBaseEntities.AnalysisSet, FieldType.Boolean));
    questionFields.push(questionFiled("hijriDate", DomainBaseEntities.AnalysisSet, FieldType.Boolean));
    questionFields.push(questionFiled("printDocumentsOnSave", DomainBaseEntities.AnalysisSet, FieldType.Boolean));
    let defaultValues = [];
    defaultValues.push({id: "legalEntity", value: toString(FieldType.Reference, app.instance.loginPresenter.loginInfo.dimensions.legalEntity)});
    defaultValues.push({id: "branch", value: toString(FieldType.Reference, app.instance.loginPresenter.loginInfo.dimensions.branch)});
    defaultValues.push({id: "sector", value: toString(FieldType.Reference, app.instance.loginPresenter.loginInfo.dimensions.sector)});
    defaultValues.push({id: "department", value: toString(FieldType.Reference, app.instance.loginPresenter.loginInfo.dimensions.department)});
    defaultValues.push({id: "analysisSet", value: toString(FieldType.Reference, app.instance.loginPresenter.loginInfo.dimensions.analysisSet)});
    defaultValues.push({id: "BARCODEON", value: app.instance.loginPresenter.loginInfo.barCodeOn});
    defaultValues.push({id: "alwaysPrint1InBarcode", value: app.instance.loginPresenter.loginInfo.alwaysPrint1InBarcode});
    defaultValues.push({id: "directPrint", value: app.instance.loginPresenter.loginInfo.directPrint});
    defaultValues.push({id: "hijriDate", value: app.instance.loginPresenter.loginInfo.hijriDate});
    defaultValues.push({id: "printDocumentsOnSave", value: currentUserSettings().printDocumentsOnSave});
    questionFieldsEditor.onDataChanged = (filedId, filedValue, cellOptions, filedEntityType) => {
        calculateOtherDims(filedEntityType, filedValue, questionFieldsEditor);
    }
    questionFieldsEditor.edit(questionFields, defaultValues, null, null, null, changeDimWindow, changeDimWindow);
    changeDimWindow.showWindow();
}

export function showPasswordMustBeChangedDialog() {
    let req = {};
    req.owner = {ownerType: OwnerType.Entity, ownerId: DomainBaseEntities.User};
    req.properties = [PreferencesRequest.META_DATA];

    metadata.fetchPreferences(req, (preferences) => {
        let helper = {};
        helper.updateRelatedFields = () => {
            return false
        };
        helper.onGuiActionUpdateList = () => {
            return false
        };
        helper.onRefresh = () => {
            logout();
        };
        helper.entityType =
            DomainBaseEntities.User;
        helper.entityMetaData = () => {
            return preferences.metaData
        };
        helper.accessor = () => {
            return null
        };
        helper.isRecordNotSaved = () => {
            return false
        };
        helper.addContextFieldsToAction = (requester, contextFieldIds, contextRow, contextFields) => {
            contextFields[CommonFieldIds.ID] = createGenericValueForType(CommonFieldIds.ID, currentUserId(), FieldType.Text)
        };
        new ActionHandler(of("setNewPassword"), DomainBaseEntities.User, preferences.metaData, new GuiActionPerformer()).performAction(helper);
    });
}

/**
 *
 * @param {namaTypes.CurrentLoginInfo} LoginInfo
 */
function reLogin(loginInfo) {
    if (loginInfo && loginInfo.userInfo && loginInfo.userInfo.settings.passwordMustBeChanged) {
        showPasswordMustBeChangedDialog();
        return;
    }
    app.instance.loginPresenter.loginInfo = loginInfo;
    /**
     *
     * @type {namaTypes.ReloginInfo}
     */
    let reloginInfo =
        {
            alwaysPrint1InBarcode: loginInfo.alwaysPrint1InBarcode,
            barCodeOn: loginInfo.barCodeOn,
            directPrint: loginInfo.directPrint,
            hijriDate: loginInfo.hijriDate,
            printDocumentsOnSave: loginInfo.userInfo.settings.printDocumentsOnSave
        };
    ajaxJSON(urls.ReLogin, {
            loginInfo: JSON.stringify(reloginInfo)
        }, () => {
            location.reload();
            $('#currentLegalEntity').text(currentLegalEntity());
        }
    );
}